import { CoinInfo, CommonWalletInfo, CoinDetailJson } from './common';

export type PostSyncOrderStatusParams = CommonWalletInfo & {
  orderCode: string;
  orderTxId: number;
  status: number;
};

export type PostBindOrderTxParam = CommonWalletInfo & {
  orderCode: string;
  orderTxId: number;
  txHash: string;
};

export enum OrderStatus {
  INIT = -1,
  PENDING = 0,
  SUCCESS = 1,
  FAIL = 2,
  FAIL_PARTIAL = 3,
  CANCEL = 4,
  TIMEOUT = 9,
}

export type OrderStatusData = {
  finishTime: number;
  status: OrderStatus;
  hash: string;
};

export type GetOrderStatusRes = OrderStatusData;

export type GetOrderPageParam = {
  chainId: number;
  poolId: number;
  pageNo: number;
  pageSize: number;
  walletAddresses: {
    chainId: number;
    walletAddress: string;
  }[];
};

export enum OrderType {
  AddLiquidity = 1,
  RemoveLiquidity = 2,
  Claim = 3,
  //取消赎回
  CancelRedemption = 7,
}

export enum OrderStatus {
  Pending = 0,
  Success = 1,
  Failed = 2,
}

export type OrderData = {
  actualAmount: string;
  actualCoinName: string;
  createAt: number;
  lpTokens: string;
  poolName: string;
  failureMsg: string;
  poolType: string;
  poolCode: string;
  chainCode: string;
  status: OrderStatus;
  type: OrderType;
  txUrl: string;
  from: string;
  to: string;
  gasFee: string;
  slippage: string | null;
  orderCode: string;
  icon: {
    day: string;
    night: string;
  };
  lpCoin: string;
  contractList: CoinInfo[];
  stakingInfoList: CoinInfo[];
  lpCoinDetail: CoinInfo;
  poolIcons: CoinDetailJson[];
  delay?: boolean;
  poolId?: number;
  subType?: StakingOrderSubType;
};

export enum StakingOrderSubType {
  /** 未知 */
  unknown = 0,
  // 质押
  stake = 1,
  // 立即赎回
  instantRedem = 2,
  // 延迟赎回
  postpRedemp = 3,
  // 获取收益
  earningWithdrawal = 4,
  // 提取本金
  princWithdrawal = 5,
  // min Lbtc
  stakeMint = 6,
  // 取消赎回
  cancelRedemption = 7,
}

export type GetOrderPageRes = {
  dataList: OrderData[];
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalNum: number;
    totalPage: number;
  };
};
